export default "__VITE_ASSET__b4c65213__"